export default "__VITE_ASSET__BTeN4Ckc__"